module.exports = __webpack_public_path__ + "static/media/c_growth.f5b0a38c.svg";